<ng-container *ngIf="useServiceDetailWrapper; else noWrapper">
    <app-service-detail #ServiceDetailComponent [context]="context" [location]="'nav.bots'">

        <ng-container *ngTemplateOutlet="content"></ng-container>
    </app-service-detail>
</ng-container>

<ng-template #noWrapper>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #content>
    <div
        class="row w-100 m-0 position-relative  {{hideList ? 'mb-0' : 'mb-4'}} {{showBotAdd ? 'high-index': ''}} bots-header">
        <div class="col-md-12 p-0 ml-auto" style="position: relative;">
            <!-- Search -->
            <div class="row list-header my-0">
                <!--
                <div class="col-8">
                    <a *ngIf="!showCVFMapping && hideList" class="list-header-back-icon" tooltip="{{'Back to list' | translate}}" placement="right" routerLink="/services/{{serviceId}}/bots/"><i class="fas fa-angle-left"></i></a>
                    <a *ngIf="showCVFMapping && hideList" class="list-header-back-icon" (click)="showCVFMapping = false; hideList = false;" tooltip="{{'Back to list' | translate}}" placement="right"><i class="fas fa-angle-left"></i></a>
                    <h1 class="list-header-title bots {{hideList ? 'mb-0' : ''}}">{{'Bots available in the service' | translate}}</h1>
                </div>
                -->
                <div class="col px-md-5" *ngIf="hideList">
                    <div class="d-inline-flex ml-3">
                        <ul class="nav nav-tabs nav-pill d-flex text-center styleguide-tabs">
                            <li class="nav-item mr-3">
                                <a routerLink="/services/{{serviceId}}/bots/"
                                    (click)="showCVFMapping ? backFromCVFMapping() : ''" class="nav-link"><i
                                        class="fas fa-angle-left mr-2"></i>{{ 'Back to list' | translate }}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div *ngIf="!hideList"
                    class="{{store.state.common.helpToggleEnabled ? 'col-md-11' : 'col-md-12' }} col-xl-8 mt-3">
                    <div class="list-search-container {{ store.state.common.helpToggleEnabled ? '' : '' }}"
                        (click)="$event.stopPropagation()">
                        <i class="fas fa-search list-search-icon" *ngIf="!hideSearch"></i>
                        <search-select *ngIf="hideList" class="w-100" [simpleList]=true [hideSelected]=true
                            [classes]="'no-border'" [items]="botsSearch" [placeholder]="'Search' | translate"
                            (change)="onBotChange($event)">
                        </search-select>
                        <form *ngIf="!hideList" class="list-search-form align-items-center">
                            <input *ngIf="!hideSearch" placeholder="{{ 'Search' | translate }}"
                                class="list-search-input" (click)="$event.stopPropagation()"
                                (input)="searchTextChanged($event.target.value)" [(ngModel)]="searchValue"
                                name="newModalName" type="text" />
                            <i *ngIf="customFilterBy" (click)="resetSearch()"
                                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                                aria-hidden="true"></i>
                        </form>
                        <button (click)="openNewRoleLayer()" class="btn btn-sm btn-primary mr-1">{{'Add' |
                            translate}}</button>
                        <span #ref class="{{ ref.children.length == 0 ? 'hidden' : '' }}">
                            <ng-content></ng-content>
                        </span>
                    </div>
                </div>

            </div>
        </div>

        <app-list-grid class="col-md-12 p-0 ml-auto aligned padding mt-3"
            *ngIf="!hideList && (botsByData | filterBy: customFilter).length > 0" [items]="botsByData"
            [determinantMapById]="determinantMapById" [hideSearch]=true [isCollapsible]="true" [baseUrl]="baseUrl"
            [orderedMenuRoles]="orderedmenuBots" [expanded]=true [rolesFlow]=false [statusIcons]=false
            [listToggle]=false botType="data" [muleServices]="muleServices" [showStatus]="true" [botCounters]=true
            headingText="{{'Data bots' | translate}}" headingTextSize="SMALL" (updateFunction)="updateBot($event)"
            (deleteFunction)="deleteBot($event)" createNewText1Part="Select an existing bot or click on"
            createNewText2Part="to create a new bot" [customFilter]="customFilterBy" [hasTutorial]=true
            [context]="context" [isCollapsed]="false" [contextProperty]="'service'"
            [tutorialProperty]="'serviceBotsData'" (saveTutorial)="serviceDetailComponent.updateService()"
            [showCopyButton]="true" (requestCopy)="copyBot($event)">
            <a (click)="openNewRoleLayer()" class="btn list-search-add">{{'Add' | translate}}</a>
        </app-list-grid>
        <app-list-grid class="col-md-12 p-0 ml-auto aligned padding mt-3"
            *ngIf="!hideList && (botsByDoc | filterBy: customFilter).length > 0" [items]="botsByDoc"
            [determinantMapById]="determinantMapById" [hideSearch]=true [isCollapsible]="true" [baseUrl]="baseUrl"
            [orderedMenuRoles]="orderedmenuBots" [expanded]=true [rolesFlow]=false [statusIcons]=false
            [listToggle]=false [botCounters]=true botType="document" headingText="{{'Document bots' | translate}}"
            headingTextSize="SMALL" (updateFunction)="updateBot($event)" (deleteFunction)="deleteBot($event)"
            createNewText1Part="Select an existing bot or click on" createNewText2Part="to create a new bot"
            [customFilter]="customFilterBy" [hasTutorial]=true [context]="context" [isCollapsed]="true"
            [contextProperty]="'service'" [tutorialProperty]="'serviceBotsDocuments'"
            (saveTutorial)="serviceDetailComponent.updateService()" [showCopyButton]="true"
            (requestCopy)="copyBot($event)">
        </app-list-grid>
        <app-list-grid class="col-md-12 p-0 ml-auto aligned padding mt-3"
            *ngIf="!hideList && botsInternal && (botsInternal | filterBy: customFilter).length > 0"
            [items]="botsInternal" [determinantMapById]="determinantMapById" [hideSearch]=true [isCollapsible]="true"
            [baseUrl]="baseUrl" [orderedMenuRoles]="orderedmenuBots" [expanded]=true [rolesFlow]=false
            [statusIcons]=false [showStatus]="true" [listToggle]=false [botCounters]=true botType="internal"
            headingText="{{'Internal bots' | translate}}" headingTextSize="SMALL" (updateFunction)="updateBot($event)"
            (deleteFunction)="deleteBot($event)" createNewText1Part="Select an existing bot or click on"
            createNewText2Part="to create a new bot" [customFilter]="customFilterBy" [hasTutorial]=true
            [isCollapsed]="true" [context]="context" [contextProperty]="'service'"
            [tutorialProperty]="'serviceBotsInternal'" (saveTutorial)="serviceDetailComponent.updateService()"
            [showCopyButton]="true" (requestCopy)="copyBot($event)">
        </app-list-grid>
        <app-list-grid class="col-md-12 p-0 ml-auto aligned padding mt-3"
            *ngIf="!hideList && botsByMessage && (botsByMessage | filterBy: customFilter).length > 0"
            [items]="botsByMessage" [hideSearch]=true [baseUrl]="baseUrl" [orderedMenuRoles]="orderedmenuBots"
            [expanded]=true [rolesFlow]=false [statusIcons]=false [showStatus]="true" [listToggle]=false
            [isCollapsible]="true" [isCollapsed]="true" [botCounters]=true botType="message"
            headingText="{{'Message bots' | translate}}" headingTextSize="SMALL" (updateFunction)="updateBot($event)"
            (deleteFunction)="deleteBot($event)" createNewText1Part="Select an existing bot or click on"
            createNewText2Part="to create a new bot" [customFilter]="customFilterBy" [hasTutorial]=true
            [context]="context" [contextProperty]="'service'" [tutorialProperty]="'serviceBotsByMessage'"
            (saveTutorial)="serviceDetailComponent.updateService()" [showCopyButton]="true"
            (requestCopy)="copyBot($event)">
        </app-list-grid>
        <div class="col-md-12 p-0 ml-auto aligned padding mt-3" *ngIf="!hideList">
            <!-- Header -->
            <div class="list-header row mb-1">
                <div class="col-8">
                    <span class="list-header-title user-feedback">
                        <b>{{ "CVF Mapping" | translate }}</b>
                    </span>
                </div>
            </div>
            <div class="expanded-list unsortable-list row">
                <div class="col-md-12 col-xl-8 list-item-container">
                    <div class="d-flex item py-2">
                        <div class="d-flex align-items-center col" (click)="showCVFMapping = true; hideList = true;">
                            <span class="mx-2">
                                <i placement="right" class="fa-light fa-arrows-split-up-and-left fa-rotate-90"
                                    placement="right" tooltip="Copy Value From"></i>
                            </span>
                            <span class="mx-2">{{"Copy Value From form field to form field" | translate}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <cvf-mapping class="w-100" *ngIf="showCVFMapping"></cvf-mapping>
        <app-new-bot *ngIf="showBotAdd" (modalClosedEvent)="closeLayer();" (modalAddedEvent)="addedBot();"
            [botName]="botNameField" [showBotAdd]="showBotAdd"></app-new-bot>
        <div class="shadow"></div>
    </div>
    <div class="col-md-12 ml-auto px-md-5 pt-0" *ngIf="hideList">
        <ng-content></ng-content>
    </div>